<template>
  <v-application :navigationRight="navigation" PurchasePricing>
    <v-card class="ma-2">
      <v-card-text>
        <v-layout row>
          <v-flex md3 px-2>
            <v-list-item>
              <v-list-item-content class="ma-0">
                <v-list-item-title class="title">{{
                  invData ? invData.p_order : ""
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-flex>
          <v-flex md3 px-2 class="ma-0">
            <v-list-item>
              <v-list-item-content class="ma-0">
                <v-list-item-title class="title">{{
                  invData ? invData.service_name : ""
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-flex>
          <v-flex md3 px-2 class="ma-0">
            <v-autocomplete
              outlined
              multiple
              v-model="sservices"
              :label="$t('store')"
              v-bind:items="all_services"
              item-text="name"
              item-value="_id"
              ref="service"
              :rules="[fieldRules.required]"
            />
          </v-flex>
          <v-flex md3 px-2 class="text-right">
            <v-btn color="primary" icon @click="navigation = true">
              <v-icon>mdi-settings</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-card class="ma-2 mt-5">
      <v-card-text>
        <v-data-table
          v-model="selectedItems"
          :items-per-page="500"
          :items="items"
          show-select
          :headers="headers"
          disable-sort
          hide-default-footer
          item-key="_id"
        >
          <template #[`item.cost`]="{ item }">{{
            typeof item.cost == typeof 5
              ? (Math.round(item.cost * 100) / 100).toLocaleString()
              : item.cost
          }}</template>
          <!-- prices -->
          <template #[`item.from1`]="{ item }">
            <v-text-field
              v-model="item.from1"
              class="right-input"
              type="number"
              @focus="$event.target.select()"
            ></v-text-field>
          </template>
          <template #[`item.from2`]="{ item }">
            <v-text-field
              v-model="item.from2"
              class="right-input"
              type="number"
              @focus="$event.target.select()"
            ></v-text-field>
          </template>
          <template #[`item.from3`]="{ item }">
            <v-text-field
              v-model="item.from3"
              class="right-input"
              type="number"
              @focus="$event.target.select()"
            ></v-text-field>
          </template>
          <template #[`item.price1`]="{ item }">
            <vuetify-money
              class="right-input"
              v-bind:options="
                item.price_currency == 'usd' ? moneyOptionsUSD : moneyOptions
              "
              v-model="item.price1"
            ></vuetify-money>
          </template>
          <template #[`item.price2`]="{ item }">
            <vuetify-money
              class="right-input"
              v-bind:options="
                item.price_currency == 'usd' ? moneyOptionsUSD : moneyOptions
              "
              v-model="item.price2"
            ></vuetify-money>
          </template>
          <template #[`item.price3`]="{ item }">
            <vuetify-money
              class="right-input"
              v-bind:options="
                item.price_currency == 'usd' ? moneyOptionsUSD : moneyOptions
              "
              v-model="item.price3"
            ></vuetify-money>
          </template>
          <!-- single price -->
          <template #[`item.price`]="{ item }">{{
            item.price
              ? (
                  Math.round(item.price * currency_value) / currency_value
                ).toLocaleString()
              : item.price
          }}</template>
          <template #[`item.margin`]="{ item }">{{
            item.price && item.cost
              ? Math.round(((item.price - item.cost) / item.cost) * 100) + " %"
              : ""
          }}</template>
          <template #[`item.margin_next`]="{ item }">{{
            item.price_next && item.cost
              ? Math.round(((item.price_next - item.cost) / item.cost) * 100) +
                " %"
              : ""
          }}</template>
          <template #[`item.price_next`]="{ item }">
            <vuetify-money
              class="right-input"
              v-bind:options="
                item.purchase_cost_currency == 'usd' || currency_value == 100
                  ? moneyOptionsUSD
                  : moneyOptions
              "
              v-model="item.price_next"
            ></vuetify-money>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-card class="ma-2 mt-5 mb-10" color="transparent" flat>
      <hr class="my-4" />
      <v-layout row mx-2 width="800">
        <hr />
        <v-flex md12>
          <v-layout row>
            <v-spacer />
            <v-btn tile class="mx-4" @click="cancelClicked">{{
              $t("cancel")
            }}</v-btn>
            <v-btn
              :loading="processing"
              :disabled="processing"
              tile
              color="primary"
              ml-2
              @click="createPricing"
              >{{ $t("update_prices") }}</v-btn
            >
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>

    <template #right-drawer>
      <v-layout row px-4 pt-2>
        <v-spacer />
        <v-hover #default="{ hover }">
          <v-btn icon @click="navigation = false">
            <v-icon :class="hover ? 'black--text rotate90' : 'grey--text'"
              >mdi-close</v-icon
            >
          </v-btn>
        </v-hover>
      </v-layout>
      <v-list>
        <v-card-text v-if="single_price">
          <v-layout row px-2>
            <v-text-field
              v-model.number="price_percent"
              :label="$t('percent')"
              type="number"
              suffix="%"
              ref="percent"
              :rules="[fieldRules.require]"
              @focus="$event.target.select()"
            ></v-text-field>
          </v-layout>
        </v-card-text>
        <v-card-text v-else class="px-0">
          <v-layout row px-4>
            <v-flex md6 px-2>
              <v-text-field
                v-model.number="froms[0]"
                :label="$t('1 qty')"
                type="number"
                @focus="$event.target.select()"
              ></v-text-field>
            </v-flex>
            <v-flex md6 px-2>
              <v-text-field
                v-model.number="price_percents[0]"
                :label="$t('percent1')"
                type="number"
                suffix="%"
                @focus="$event.target.select()"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row px-4>
            <v-flex md12 px-2>
              <v-select
                v-model.number="actions[0]"
                :label="$t('action')"
                :items="actionsList"
              ></v-select>
            </v-flex>
          </v-layout>
          <hr class="mb-5" style="border: 0.5px dashed lightgrey" />

          <v-layout row px-4>
            <v-flex md6 px-2>
              <v-text-field
                v-model.number="froms[1]"
                :label="$t('2 qty')"
                type="number"
                @focus="$event.target.select()"
              ></v-text-field>
            </v-flex>
            <v-flex md6 px-2>
              <v-text-field
                v-model.number="price_percents[1]"
                :label="$t('percent2')"
                type="number"
                suffix="%"
                @focus="$event.target.select()"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row px-4>
            <v-flex md12 px-2>
              <v-select
                v-model.number="actions[1]"
                :label="$t('action')"
                :items="actionsList"
              ></v-select>
            </v-flex>
          </v-layout>
          <hr class="mb-5" style="border: 0.5px dashed lightgrey" />

          <v-layout row px-4>
            <v-flex md6 px-2>
              <v-text-field
                v-model.number="froms[2]"
                @focus="$event.target.select()"
                :label="$t('3 qty')"
              ></v-text-field>
            </v-flex>
            <v-flex md6 px-2>
              <v-text-field
                v-model.number="price_percents[2]"
                :label="$t('percent3')"
                type="number"
                suffix="%"
                @focus="$event.target.select()"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row px-4>
            <v-flex md12 px-2>
              <v-select
                v-model.number="actions[2]"
                :label="$t('action')"
                :items="actionsList"
              ></v-select>
            </v-flex>
          </v-layout>
          <hr class="mb-5" style="border: 0.5px dashed lightgrey" />
        </v-card-text>
        <v-card-text>
          <v-layout px-2>
            <v-radio-group
              class="ma-0 pa-0"
              v-model="round_type"
              row
              :rules="[fieldRules.require]"
            >
              <v-radio :label="$t('no_rounding')" value="no_round" />
              <v-radio :label="$t('rounding_to_50_summ')" value="round_50" />
              <v-radio :label="$t('rounding_to_500_summ')" value="round_500" />
            </v-radio-group>
          </v-layout>
          <v-layout row px-2>
            <v-flex md12 px-2 class="text-right">
              <v-btn color="primary" @click="applyPrices">{{
                $t("apply")
              }}</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-list>
    </template>

    <v-snackbar
      v-model="processing_error"
      color="error"
      :timeout="3000"
      right
      top
      >{{ $t("couldnot_update_prices") }}</v-snackbar
    >
  </v-application>
</template>

<script>
import Services from "../../mixins/services";
import Currency from "../../mixins/settings/currency";

export default {
  name: "purchase-pricing",
  mixins: [Currency, Services],
  data: () => ({
    current_service: null,
    navigation: false,
    single_price: true,
    items: [],
    price_percent: 0,
    from: 0,
    froms: [0, 0, 0],
    price_percents: [0, 0, 0],
    actions: ["both", "both", "both"],
    round_type: "round_50",
    selectedItems: [],
    invData: null,
    processing: false,
    processing_error: false,
    currency_value: 1,
    all_services: [],
    sservices: [],
  }),
  watch: {
    currency: {
      deep: true,
      handler() {
        if (this.currency && this.currency.currency) {
          this.currency_value = this.currency.currency == "usd" ? 100 : 1;
        }
      },
    },
  },
  computed: {
    actionsList() {
      return [
        {
          text: this.$t("both"),
          value: "both",
        },
        {
          text: this.$t("quantity"),
          value: "quantity",
        },
        {
          text: this.$t("price"),
          value: "price",
        },
        {
          text: this.$t("none"),
          value: "none",
        },
      ];
    },
    query() {
      return this.$route.query;
    },
    target() {
      return this.$route.params["target"];
    },
    headers() {
      if (this.single_price) {
        return [
          { text: this.$t("item"), value: "name", align: "left" },
          { text: this.$t("cost"), value: "cost", align: "right", width: 120 },
          {
            text: this.$t("margin"),
            value: "margin",
            align: "right",
            width: 120,
          },
          {
            text: this.$t("price"),
            value: "price",
            align: "right",
            width: 120,
          },
          {
            text: this.$t("margin_next"),
            value: "margin_next",
            align: "right",
            width: 120,
          },
          {
            text: this.$t("price_next"),
            value: "price_next",
            align: "right",
            width: 120,
          },
        ];
      } else {
        return [
          { text: this.$t("item"), value: "name", align: "left" },
          { text: this.$t("cost"), value: "cost", align: "right" },
          { text: this.$t("quantity"), value: "quality", align: "right" },
          { text: this.$t("1 qty"), value: "from1", align: "right" },
          { text: this.$t("price1"), value: "price1", align: "right" },
          { text: this.$t("2 qty"), value: "from2", align: "right" },
          { text: this.$t("price2"), value: "price2", align: "right" },
          { text: this.$t("3 qty"), value: "from3", align: "right" },
          { text: this.$t("price3"), value: "price3", align: "right" },
        ];
      }
    },
  },
  methods: {
    async getAccess() {
      const access = this.$communicator.then(
        this,
        await this.$communicator("get_access")
      );
      if (access && access.feature && access.feature.prices) {
        this.single_price = false;
      } else {
        this.single_price = true;
      }
    },
    async checkQuery() {
      switch (this.target) {
        case "purchase": {
          const data = this.$communicator.then(
            this,
            await this.$communicator("purchase_by_id", {
              arguments: [this.query.id],
            })
          );
          if (data && data.items instanceof Array) {
            this.invData = data;
            const items = [];
            const exist = {};
            for (const item of data.items) {
              if (exist[item.product_id] == undefined) {
                exist[item.product_id] = items.length;
                items.push({
                  _id: item.product_id,
                  name: item.product_name,
                  sku: item.sku,
                  barcode: item.barcode,
                  quality: item.quality,
                  price: item.price,
                  cost: item.cost,
                });
              } else {
                items[exist[item.product_id]].quality += item.quality;
              }
            }
            this.current_service = data.service;
            this.refreshItems(items);
          }
          break;
        }
      }
    },
    async refreshItems(itemIds) {
      const ids = [];
      for (const itm of itemIds) {
        ids.push(itm._id);
      }
      const items = this.$communicator.then(
        this,
        await this.$communicator("inv_items_refresh", {
          params: {
            service: this.current_service,
            indexes: ids,
            inv_id: this.invData ? this.invData._id : undefined,
          },
        })
      );

      if (items instanceof Array) {
        const ITEMS = [];
        const resMap = {};
        for (const it of items) {
          resMap[it._id] = it;
        }
        for (const it of itemIds) {
          if (resMap[it._id]) {
            const currentItem = {};
            if (!(resMap[it._id].prices instanceof Array)) {
              resMap[it._id].prices = [];
            }
            if (resMap[it._id].prices.length > 0) {
              currentItem.from1 = resMap[it._id].prices[0].from;
              currentItem.price1 = resMap[it._id].prices[0].price;
            }

            if (resMap[it._id].prices.length > 1) {
              currentItem.from2 = resMap[it._id].prices[1].from;
              currentItem.price2 = resMap[it._id].prices[1].price;
            }

            if (resMap[it._id].prices.length > 2) {
              currentItem.from3 = resMap[it._id].prices[2].from;
              currentItem.price3 = resMap[it._id].prices[2].price;
            }

            if (resMap[it._id].cost) {
              currentItem.cost = resMap[it._id].cost;
            }

            ITEMS.push({
              ...it,
              ...currentItem,
              prices: resMap[it._id].prices,
            });
          }
        }
        this.items = ITEMS;
      }
    },
    applyPrices() {
      if (!(this.selectedItems instanceof Array)) {
        this.selectedItems = [];
      }

      if (!this.single_price) {
        for (const ind in this.selectedItems) {
          if (
            ["both", "quantity"].includes(this.actions[0]) &&
            typeof this.froms[0] == typeof 5
          ) {
            this.selectedItems[ind].from1 = this.froms[0];
          }

          if (
            ["both", "quantity"].includes(this.actions[1]) &&
            typeof this.froms[1] == typeof 5
          ) {
            this.selectedItems[ind].from2 = this.froms[1];
          }

          if (
            ["both", "quantity"].includes(this.actions[2]) &&
            typeof this.froms[2] == typeof 5
          ) {
            this.selectedItems[ind].from3 = this.froms[2];
          }

          if (
            ["both", "price"].includes(this.actions[0]) &&
            this.selectedItems[ind].cost
          ) {
            this.selectedItems[ind].price1 = this.rountIt(
              this.selectedItems[ind].cost * (1 + this.price_percents[0] / 100),
              this.round_type
            );
          }

          if (
            ["both", "price"].includes(this.actions[1]) &&
            this.selectedItems[ind].cost
          ) {
            this.selectedItems[ind].price2 = this.rountIt(
              this.selectedItems[ind].cost * (1 + this.price_percents[1] / 100),
              this.round_type
            );
          }

          if (
            ["both", "price"].includes(this.actions[2]) &&
            this.selectedItems[ind].cost
          ) {
            this.selectedItems[ind].price3 = this.rountIt(
              this.selectedItems[ind].cost * (1 + this.price_percents[2] / 100),
              this.round_type
            );
          }
        }
      } else {
        for (const ind in this.selectedItems) {
          if (this.selectedItems[ind].cost && this.price_percent) {
            this.selectedItems[ind].price_next = this.rountIt(
              (this.price_percent / 100 + 1) * this.selectedItems[ind].cost,
              this.round_type
            );
          }
        }
      }
      this.selectedItems.push({});
      this.selectedItems.pop();
    },
    cancelClicked() {
      this.$router.go(-1);
    },
    async createPricing() {
      this.processing = true;
      const items = [];
      for (const it of this.items) {
        const prices = [];
        if (+it.from1 || +it.from1 == 0) {
          it.from1 = +it.from1;
        }
        if (+it.price1 || +it.price1 == 0) {
          it.price1 = +it.price1;
        }
        if (typeof it.from1 == typeof 5 && typeof it.price1 == typeof 5) {
          prices.push({
            from: it.from1,
            price: it.price1,
          });
        }

        if (+it.from2 || +it.from2 == 0) {
          it.from2 = +it.from2;
        }
        if (+it.price2 || +it.price2 == 0) {
          it.price2 = +it.price2;
        }
        if (typeof it.from2 == typeof 5 && typeof it.price2 == typeof 5) {
          prices.push({
            from: it.from2,
            price: it.price2,
          });
        }

        if (+it.from3 || +it.from3 == 0) {
          it.from3 = +it.from3;
        }
        if (+it.price3 || +it.price3 == 0) {
          it.price3 = +it.price3;
        }
        if (typeof it.from3 == typeof 5 && typeof it.price3 == typeof 5) {
          prices.push({
            from: it.from3,
            price: it.price3,
          });
        }

        if (+it.price_next || +it.price_next == 0) {
          it.price_next = +it.price_next;
        }

        items.push({
          _id: it._id,
          price: typeof it.price_next == typeof 5 ? it.price_next : it.price,
          prices: prices,
        });
      }

      const res = this.$communicator.then(
        this,
        await this.$communicator("inv_pricing", {
          params: {
            service: this.current_service,
            type: this.target,
            inv_id: this.invData ? this.invData._id : undefined,
            items: items,
            services: this.sservices,
          },
        })
      );

      if (res instanceof Array) {
        this.$toast.success("Success", { timeout: 2000 });
        this.$router.push("/inventory/purchase").catch(() => {});
      } else {
        this.$toast.error("Error", { timeout: 2000 });
        this.processing = false;
        this.processing_error = true;
      }
    },
    async getservices() {
      const services = this.$communicator.then(
        this,
        await this.$communicator("services")
      );
      if (services) {
        this.all_services = this.$copy(services);
        for (const ser of this.all_services) {
          if (ser._id == this.current_service) {
            ser.disabled = true;
            this.sservices.push(ser._id);
          }
        }
      }
    },
  },
  async mounted() {
    this.getAccess();
    await this.checkQuery();
    this.getservices();
    this.get_currency();
  },
};
</script>

<style scoped>
.rotate90 {
  transform: rotate(90deg);
}
</style>
